// Import agent configurations
import {
    libertyBlackPrompt,
    libertyBlackAvatar,
} from "@/components/SystemPrompt/libertyBlackPrompt";
import {
    joiPrompt,
    joiAvatar,
} from "@/components/SystemPrompt/joiPrompt";
import {
    benonPrompt,
    benonAvatar,
} from "@/components/SystemPrompt/benonPrompt";
import {
    besaoPrompt,
    besaoAvatar,
} from "@/components/SystemPrompt/besaoPrompt";
import {
    libertyWhitePrompt,
    libertyWhiteAvatar,
} from "@/components/SystemPrompt/libertyWhitePrompt";
import {
    libertyPrompt,
    libertyAvatar,
} from "@/components/SystemPrompt/libertyPrompt";
import {
    veraPrompt,
    veraAvatar,
} from "@/components/SystemPrompt/veraPrompt";
import {
    brianPrompt,
    brianAvatar,
} from "@/components/SystemPrompt/brianPrompt";
import {
    rosaPrompt,
    rosaAvatar,
} from "@/components/SystemPrompt/rosaPrompt";
import {
    vietPrompt,
    vietAvatar,
} from "@/components/SystemPrompt/vietPrompt";
import { thuykieuAvatar, thuykieuPrompt } from "@/components/SystemPrompt/thuykieuPrompt";
import { thuykieuaodaiAvatar, thuykieuaodaiPrompt } from "@/components/SystemPrompt/thuykieuaodaiPrompt";
import { thuykieuOcopNgheAnPrompt, thuykieuOcopNgheAnAvatar } from "@/components/SystemPrompt/thuykieuOcopNgheAnPrompt";
import { thuykieuDuLichHaTinhPrompt, thuykieuDuLichHaTinhAvatar } from "@/components/SystemPrompt/thuykieuDuLichHaTinhPrompt";
import { thuykieuTet2026Prompt, thuykieuTet2026Avatar } from "@/components/SystemPrompt/thuykieuTet2026Prompt";
import { sopheaPrompt, sopheaAvatar } from "@/components/SystemPrompt/sopheaPrompt";
import { petroWhiteHatPrompt, petroWhiteHatAvatar } from "@/components/SystemPrompt/petroWhiteHatPrompt";
import { sg3dAustraliaPrompt, sg3dAustraliaAvatar } from "@/components/SystemPrompt/sg3dAustraliaPrompt";
import { generalAgentPrompt, generalAgentAvatar } from "@/components/SystemPrompt/generalAgentPrompt";

// Export list of available agents for admin UI
export const AVAILABLE_AGENTS = [
    { value: 'benon', label: 'Bé Non', description: 'Agent trẻ em giọng nam' },
    { value: 'besao', label: 'Bé Sao', description: 'Agent trẻ em giọng nữ' },
    { value: 'joi', label: 'Joi', description: 'Agent nữ hiện đại' },
    { value: 'libertyWhite', label: 'Liberty White', description: 'Agent nữ văn phòng (áo trắng)' },
    { value: 'liberty', label: 'Liberty', description: 'Agent nữ văn phòng' },
    { value: 'vera', label: 'Vera', description: 'Agent nữ văn phòng (không logo)' },
    { value: 'brian', label: 'Brian', description: 'Agent nam văn phòng' },
    { value: 'libertyBlack', label: 'Liberty Black', description: 'Agent nữ văn phòng (áo đen)' },
    { value: 'rosa', label: 'Rosa', description: 'Agent nữ thời trang' },
    { value: 'viet', label: 'Việt', description: 'Agent nam Việt Nam' },
    { value: 'thuykieu', label: 'Thúy Kiều', description: 'Agent nữ truyền thống Việt Nam' },
    { value: 'thuykieuaodai', label: 'Thúy Kiều Áo Dài', description: 'Agent nữ áo dài Việt Nam' },
    { value: 'thuykieuocopnghean', label: 'Thúy Kiều OCOP Nghệ An', description: 'Agent OCOP Nghệ An' },
    { value: 'thuykieudulichhatinh', label: 'Thúy Kiều Du lịch Hà Tĩnh', description: 'Agent du lịch Hà Tĩnh' },
    { value: 'thuykieudulichhatinh_itcudong', label: 'Thúy Kiều Du lịch Hà Tĩnh ÍT CỬ ĐỘNG', description: 'Agent du lịch Hà Tĩnh (animation v7)' },
    { value: 'sophea', label: 'Sophea', description: 'Agent trang phục Khmer' },
    { value: 'petroWhiteHat', label: 'Petro White Hat', description: 'Agent nam mũ trắng' },
    { value: 'thuykieutet2026', label: 'Thúy Kiều Tết 2026', description: 'Agent Tết 2026' },
    { value: 'sg3d-australia', label: 'SG3D Australia', description: 'Agent phong cách Úc' },
    { value: 'general-agent', label: 'General Agent', description: 'Agent tổng quát cho StarGlobal 3D' },

];

const DEFAULT_FIRE_ALERT_VIDEO_URL = 'https://sanpham.starglobal3d.vn/managements/user_FE/theme/heritage/popup_infor/audio/chua-chay.mp4';

const removeAccents = (text) => {
    // Replace 'đ' with 'd' and 'Đ' with 'D'
    text = text.replace(/đ/g, 'd').replace(/Đ/g, 'D');
    // Normalize to NFD and remove diacritical marks
    return text.normalize('NFD').replace(/[\u0300-\u036F]/g, '');
};

// Generate lipsync data from text
export const generateTextToLipsync = (text) => {
    const time = new Date().getTime();

    // Remove accents from the Vietnamese text
    const cleanedText = removeAccents(text);
    // Convert to lowercase and remove punctuation
    const processedText = cleanedText.toLowerCase().replace(/[.,!?;:]/g, '');

    // Estimate duration based on text length
    const words = processedText.trim().split(/\s+/);
    const wordCount = Math.max(words.length, 1);
    const estimatedDuration = wordCount * 0.4; // Approx. speaking rate
    const durationInSeconds = Math.max(estimatedDuration, 0.5);

    // Split into characters for viseme assignment
    const characters = processedText.split('');

    // Define vowels for timing weights
    const vowels = new Set(['a', 'e', 'i', 'o', 'u', 'y']);

    // Simple viseme map for lipsync
    const visemeMap = {
        'p': 'A', 'b': 'A', 'm': 'A',           // Closed mouth
        'k': 'B', 's': 'B', 't': 'B', 'd': 'B', // Slightly open
        'g': 'B', 'j': 'B', 'c': 'B', 'z': 'B',
        'n': 'B',
        'e': 'C',                               // Open mouth (E sound)
        'a': 'D',                               // Wide open (A sound)
        'o': 'E',                               // Rounded (O sound)
        'u': 'F', 'w': 'F',                     // Pursed lips (U, W sound)
        'f': 'G', 'v': 'G',                     // Teeth on lip
        'l': 'H', 'r': 'H',                     // Tongue raised
        'i': 'C', 'y': 'C'                      // Similar to E
    };

    // Calculate total weight for timing distribution
    let totalWeight = 0;
    for (const char of characters) {
        if (char === ' ') totalWeight += 0.5;      // Space
        else if (vowels.has(char)) totalWeight += 1.5; // Vowels
        else totalWeight += 1;                     // Consonants
    }

    // Generate mouth cues
    const mouthCues = [];
    let currentTime = 0;
    for (const char of characters) {
        let viseme, weight;
        if (char === ' ') {
            viseme = 'X';       // Closed mouth for space
            weight = 0.5;
        } else if (visemeMap[char]) {
            viseme = visemeMap[char];
            weight = vowels.has(char) ? 1.5 : 1;
        } else if (/[a-z]/.test(char)) {
            viseme = 'B';       // Default for letters
            weight = 1;
        } else {
            continue;           // Skip non-letters
        }

        const duration = weight * (durationInSeconds / totalWeight);
        if (mouthCues.length > 0 && mouthCues[mouthCues.length - 1].value === viseme) {
            // Merge consecutive identical visemes
            mouthCues[mouthCues.length - 1].end += duration;
        } else {
            mouthCues.push({ start: currentTime, end: currentTime + duration, value: viseme });
        }
        currentTime += duration;
    }

    // Adjust final cue to match total duration
    if (mouthCues.length > 0) {
        mouthCues[mouthCues.length - 1].end = durationInSeconds;
    }

    return {
        metadata: {
            soundFile: "",
            duration: durationInSeconds
        },
        mouthCues: mouthCues
    };
};

// Agent data function
export const getAgentData = (agent) => {
    switch (agent) {
        case "benon":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/be_non.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/animation_be_non.glb",
                voice: "sage",
                meshPreset: "wolf3d",
                systemPrompt: benonPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: benonAvatar,
                welcomeVoice: "/greetings/welcomeBeNon.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 0.6, 2.5, 0, 0.6, 0],   // [posX, posY, posZ, lookX, lookY, lookZ]
                    zoomed: [0, 0.6, 3, 0, 0.5, 0]
                }
            };
        case "besao":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/be_sao.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/animation_be_sao.glb",
                voice: "sage",
                meshPreset: "wolf3d",
                systemPrompt: besaoPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: besaoAvatar,
                welcomeVoice: "/greetings/welcomeBeSao.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 0.6, 2.5, 0, 0.6, 0],
                    zoomed: [0, 0.6, 3, 0, 0.5, 0]
                }
            };
        case "joi":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/joi.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/animation_joi.glb",
                voice: "shimmer",
                meshPreset: "wolf3d",
                systemPrompt: joiPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: joiAvatar,
                welcomeVoice: "/greetings/welcomeJoi.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };
        case "libertyWhite":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/office_lady_white_outfit.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/animation_office_lady.glb",
                voice: "shimmer",
                meshPreset: "wolf3d",
                systemPrompt: libertyWhitePrompt(),
                instructions: "You are a helpful assistant.",
                avatar: libertyWhiteAvatar,
                welcomeVoice: "/greetings/welcomeLiberty.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };
        case "liberty":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/679208c860fb6aaa624e9ed8.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/animations_female.glb",
                voice: "sage",
                meshPreset: "wolf3d",
                systemPrompt: libertyPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: libertyAvatar,
                welcomeVoice: "/greetings/welcomeLiberty.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };

        case "vera":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/679208c860fb6aaa624e9ed8_noLOGO.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/animations_femalev2.glb",
                voice: "sage",
                meshPreset: "wolf3d",
                systemPrompt: veraPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: veraAvatar,
                welcomeVoice: "/greetings/welcomeLiberty.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };

        case "brian":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/67b689c9ccac41f17ee6fdfb.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/animations_male.glb",
                voice: "ash",
                meshPreset: "wolf3d",
                systemPrompt: brianPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: brianAvatar,
                welcomeVoice: "/greetings/welcomeBrian.mp3",
                welcomeLipsync: "/greetings/welcomeBrian.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };
        case "libertyBlack":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/office_lady_black_outfit.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/animation_office_lady.glb",
                voice: "coral",
                meshPreset: "wolf3d",
                systemPrompt: libertyBlackPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: libertyBlackAvatar,
                welcomeVoice: "/greetings/welcomeLiberty.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };
        case "rosa":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/68a56e74645c86eae59ec895_withlogo_rosa.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/animation_rosa.glb",
                voice: "coral",
                meshPreset: "wolf3d",
                systemPrompt: rosaPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: rosaAvatar,
                welcomeVoice: "/greetings/welcomeRosa.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };
        case "viet":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/68ad60d1e2136b6911a56e73.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/animation_viet.glb",
                voice: "coral",
                meshPreset: "wolf3d",
                systemPrompt: vietPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: vietAvatar,
                welcomeVoice: "/greetings/welcomeViet.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };
        case "thuykieu":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/model-thuykieu-v2.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/animation_thuykieu.glb",
                voice: "shimmer",
                meshPreset: "thuykieu",
                systemPrompt: thuykieuPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: thuykieuAvatar,
                welcomeVoice: "/greetings/welcomeThuyKieu.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };
        case "thuykieuaodai":
            return {
                models: "/models/thuy_kieu_ao_dai_v2.gltf",
                animations: "/models/animation_thuy_kieu.glb",
                voice: "aoede",
                meshPreset: "thuykieu",
                systemPrompt: thuykieuaodaiPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: thuykieuaodaiAvatar,
                welcomeVoice: "/greetings/welcomeThuyKieu.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };
        case "thuykieuocopnghean":
            return {
                // models: "/models/thuy_kieu_ocop_nghe_an.gltf",
                // animations: "/models/animation_thuy_kieu_ocop_nghe_an.glb",          
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/ocop-nghe-an/model-ocop-nghe-an.gltf",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/ha-tinh/animation-v5.glb",
                voice: "aoede",
                meshPreset: "thuykieu",
                systemPrompt: thuykieuOcopNgheAnPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: thuykieuOcopNgheAnAvatar,
                welcomeVoice: "/greetings/welcomeThuyKieu.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };

        case "thuykieudulichhatinh":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/ha-tinh/Agent_Ao_dai_Ha_Tinh.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/ha-tinh/animation-v5.glb",
                voice: "aoede",
                meshPreset: "thuykieu",
                systemPrompt: thuykieuDuLichHaTinhPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: thuykieuDuLichHaTinhAvatar,
                welcomeVoice: "/greetings/welcomeThuyKieu.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };

        case "thuykieudulichhatinh_itcudong":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/ha-tinh/Agent_Ao_dai_Ha_Tinh.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/ha-tinh/animation_Thuy_Kieu_starglobal_v7.glb",
                voice: "aoede",
                meshPreset: "thuykieu",
                systemPrompt: thuykieuDuLichHaTinhPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: thuykieuDuLichHaTinhAvatar,
                welcomeVoice: "/greetings/welcomeThuyKieu.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };    

        case "thuykieutet2026":
            return {
                models: "/models/Agent_Ao_dai_Tet_2026_v2.glb",
                animations: "/models/animation_Thuy Kieu_starglobal.gltf",
                voice: "aoede",
                meshPreset: "thuykieu",
                systemPrompt: thuykieuTet2026Prompt(),
                instructions: "You are a helpful assistant.",
                avatar: thuykieuTet2026Avatar,
                welcomeVoice: "/greetings/welcomeThuyKieu.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };

        case "sophea":
            return {
                models: "/models/Agent_Trang_phuc_Khmer_v3.glb",
                animations: "/models/animation-khmer_v5.gltf",
                voice: "aoede",
                meshPreset: "thuykieu",
                systemPrompt: sopheaPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: sopheaAvatar,
                welcomeVoice: "/greetings/welcomeSophea.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };

        case "petroWhiteHat":
            return {
                models: "/models/petroWhiteHat.glb",
                animations: "/models/animation-petroWhiteHat.gltf",
                voice: "ash",
                meshPreset: "thuykieu",
                systemPrompt: petroWhiteHatPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: petroWhiteHatAvatar,
                welcomeVoice: "/greetings/welcomePetroWhiteHat.mp3",
                welcomeLipsync: "/greetings/welcomeBrian.json",
                fireAlertVideo: DEFAULT_FIRE_ALERT_VIDEO_URL,
                cameraConfig: {
                    normal: [0, 2.2, 5, 0, 1.0, 0],
                    zoomed: [0, 1.5, 2.5, 0, 1.51, 0]
                }
            };
        case "sg3d-australia":
            return {
                models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/australia/Thuy_Kieu_StarGlobal_v1.glb",
                animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/agent/model3d/australia/animation_Thuy Kieu_starglobal_v7.glb",
                voice: "shimmer",
                meshPreset: "thuykieu",
                systemPrompt: sg3dAustraliaPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: sg3dAustraliaAvatar,
                welcomeVoice: "/greetings/welcomeThuyKieuENG.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };
        // case "general-agent":
        //     return {
        //         models: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/15modelthuykieuaodaistarglobal3d.glb",
        //         animations: "https://s3.hcm-1.cloud.cmctelecom.vn/starglobal-3d/agent/15animationthuykieu.glb",
        //         voice: "aoede",
        //         meshPreset: "thuykieu",
        //         systemPrompt: generalAgentPrompt(),
        //         instructions: "You are a helpful assistant.",
        //         avatar: generalAgentAvatar,
        //         welcomeVoice: "/greetings/welcomeThuyKieuENG.mp3",
        //         welcomeLipsync: "/greetings/welcomeLiberty.json",
        //         cameraConfig: {
        //             normal: [0, 2.2, 6, 0, 1.0, 0],
        //             zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
        //         }
        //     };
        default:
            return {
                models: "/models/thuy_kieu_ao_dai_v2.gltf",
                animations: "/models/animation_thuy_kieu.glb",
                voice: "aoede",
                meshPreset: "thuykieu",
                systemPrompt: thuykieuaodaiPrompt(),
                instructions: "You are a helpful assistant.",
                avatar: thuykieuaodaiAvatar,
                welcomeVoice: "/greetings/welcomeThuyKieu.mp3",
                welcomeLipsync: "/greetings/welcomeLiberty.json",
                cameraConfig: {
                    normal: [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: [0, 1.5, 1.5, 0, 1.51, 0]
                }
            };
    }
};

/**
 * Fetch custom agent config from API and merge with default agent data
 * @param {string} agentCode - The agent code (e.g., 'liberty', 'sophea')
 * @param {string} idPath - The project ID path
 * @returns {Promise<Object>} - Merged agent data with custom config
 */
export const getAgentDataWithCustomConfig = async (agentCode, idPath) => {
    // Get default agent data first
    const defaultData = getAgentData(agentCode);

    if (!idPath) {
        return defaultData;
    }

    try {
        // Use PUBLIC endpoint - no authentication required
        const response = await fetch(`/api/proxy/v1/projects/agent-config/public?id_path=${encodeURIComponent(idPath)}`);

        if (!response.ok) {
            console.log('No custom agent config found, using defaults');
            return defaultData;
        }

        const result = await response.json();

        if (result.success && result.data) {
            const customConfig = result.data;

            // Merge custom config with default data
            // Custom config overrides default values if present
            const mergedData = {
                ...defaultData,
                // Override system prompt if custom one exists
                systemPrompt: customConfig.system_prompt || defaultData.systemPrompt,
                // Override voice if custom one exists
                voice: customConfig.voice_type || defaultData.voice,
                // Override welcome voice - use welcome_voice_url (full_url has backend bug)
                welcomeVoice: customConfig.welcome_voice_url || customConfig.welcome_voice_full_url || defaultData.welcomeVoice,
                // Override fire alert video if custom one exists
                fireAlertVideo: customConfig.fire_alert_video_url || customConfig.fire_alert_video_full_url || defaultData.fireAlertVideo || DEFAULT_FIRE_ALERT_VIDEO_URL,
                // Override camera config if custom one exists
                cameraConfig: {
                    normal: customConfig.camera_normal || defaultData.cameraConfig?.normal || [0, 2.2, 6, 0, 1.0, 0],
                    zoomed: customConfig.camera_zoomed || defaultData.cameraConfig?.zoomed || [0, 1.5, 1.5, 0, 1.51, 0]
                },
                // Override mesh preset from Admin (wolf3d/thuykieu/auto)
                meshPreset: customConfig.mesh_preset || defaultData.meshPreset || 'wolf3d',
                // Override mesh config for 'auto' preset (custom GLTF node mapping)
                meshConfig: customConfig.mesh_config || defaultData.meshConfig,
                // Visual capture: whether AI can see the 360° canvas in realtime
                enableVisualCapture: !!customConfig.enable_visual_capture,
                // Full 360° capture: whether AI can capture and analyze the entire 360° scene
                enableFull360Capture: !!customConfig.enable_full_360_capture,
                // Mark as custom config
                isCustomConfig: customConfig.is_custom || true,
                // Chat input config toggle from admin
                enableChatInput: customConfig.enable_chat_input !== undefined ? Boolean(Number(customConfig.enable_chat_input)) : false,
                searchMode: customConfig.search_mode || 'hybrid'
            };

            // Override model/animation URLs if custom agent models exist
            if (customConfig.custom_agent_models && Array.isArray(customConfig.custom_agent_models)) {
                const matched = customConfig.custom_agent_models.find(
                    (m) => m.code === agentCode
                );
                if (matched) {
                    if (matched.modelUrl) mergedData.models = matched.modelUrl;
                    if (matched.animationUrl) mergedData.animations = matched.animationUrl;
                    // Only apply custom agent voice if no per-project voice_type is explicitly set
                if (matched.voice && !customConfig.voice_type) mergedData.voice = matched.voice;
                    if (matched.meshPreset || matched.mesh_preset) mergedData.meshPreset = matched.meshPreset || matched.mesh_preset;
                    
                    let rawMeshConfig = matched.meshConfig || matched.mesh_config;
                    if (typeof rawMeshConfig === 'string') {
                        try {
                            rawMeshConfig = JSON.parse(rawMeshConfig);
                        } catch (e) {
                            console.error("Failed to parse mesh config", e);
                        }
                    }
                    if (rawMeshConfig) mergedData.meshConfig = rawMeshConfig;

                    // Clear the hardcoded default avatar (e.g., libertyAvatar) so the frontend uses dynamic getSkinnedMeshRenderer instead
                    mergedData.avatar = undefined;
                    mergedData.isCustomAgentModel = true;
                }
            }

            return mergedData;
        }

        return defaultData;
    } catch (error) {
        console.error('Error fetching custom agent config:', error);
        return defaultData;
    }
};